<template>
  <q-section v-bind="$attrs" :key="active" :bg-i="tabs[active]" class="flex justify-between">
    <q-section
      v-for="(tab, index) in tabs"
      :key="index"
      h="100%"
      :w="`${100 / tabs.length}%`"
      @click="handleTabClick(index)"
      p="relative"></q-section>
  </q-section>
</template>

<script setup lang="ts">
import { trackEvent } from '@/utils/tracking_utils'
import { user } from '@/state/user'

const props = defineProps({
  tabs: {
    type: Array<string>,
    required: true,
  },
  active: {
    type: Number,
    default: 0,
  },
  tracks: {
    type: Array<string>,
    required: false,
    default: () => [],
  },
  scene: {
    type: String,
    required: false,
    default: '',
  },
})

const emit = defineEmits(['update:modelValue'])
const handleTabClick = (index: number) => {
  emit('update:modelValue', index)
  if (props.tracks.length > 0) {
    trackEvent(user, props.scene, {
      button_name: props.tracks[index],
    })
  }
}
</script>

<style scoped lang="scss"></style>
